import {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';

import {Dialog} from 'primereact/dialog';
import {Button} from 'primereact/button';
import {InputText} from 'primereact/inputtext';

import {LoginService} from '../login/LoginService';

import {AppStorage} from '../../service/UserStorage';
import {RadioButton} from 'primereact/radiobutton';
import Email from './components/Email';
import UsbToken from './components/UsbToken';

export default function ForgotPassword() {
  const [selectedMethod, setSelectedMethod] = useState('email');
  const [displayDone, setDisplayDone] = useState(false);
  const [displayChangePassDone, setDisplayChangePassDone] = useState(false);


  return (
    <div className="layout-wrapper layout-overlay layout-theme-light" style={{backgroundColor: '#fff', height: '100vh'}}>
      <div className="layout-main p-3 h-full">
        <div className="grid h-full">
          <div className="sm:hidden md:block lg:block xl:block md:col-8 lg:col-8 xl:col-7" style={{backgroundImage: 'url(/assets/layout/images/bg-4.png)', backgroundSize: 'contain', backgroundRepeat: 'no-repeat'}}>
            <div className="p-5">
              <div className="mt-2">
                <img src={'/assets/layout/images/logo-letter-14.png'} alt="logo" />
              </div>
            </div>
          </div>
          <div className="col-12 md:col-4 lg:col-4 xl:col-5 flex justify-content-center align-content-center flex-wrap">
            <div className="card surface-ground" style={{width: '486px'}}>
              <div className="text-center">
                <img src={'/assets/layout/images/logo-minvoice.png'} alt="logo" />
              </div>

              <div className="mt-3 mb-3 pb-2 border-bottom-1 pl-3">
                <h5 className="text-center mb-4">Chọn phương thức lấy lại mật khẩu</h5>
                <div className="mb-3 flex align-items-center">
                  <RadioButton inputId="email" name="email" value="email" onChange={() => setSelectedMethod('email')} checked={selectedMethod === 'email'} />
                  <label htmlFor="email" className="ml-2 text-lg">
                    Lấy lại mật khẩu qua email đăng ký
                  </label>
                </div>
              </div>
              {selectedMethod === 'email' ? <Email setDisplayDone={setDisplayDone} /> : <UsbToken setDisplayChangePassDone={setDisplayChangePassDone} />}
            </div>
          </div>
        </div>
      </div>
      <Dialog visible={displayDone} style={{width: '40rem'}} onHide={() => setDisplayDone(false)} closable={false}>
        <p>
          <h5>Đặt lại mật khẩu thành công!</h5>
        </p>
        <p>Mật khẩu mới đã được gửi về email của quý khách, quý khách vui lòng sử dụng mật khẩu mới để đăng nhập.</p>
        <div className="flex justify-content-center mt-4">
          <Link to="/login">
            <Button label="Quay lại đăng nhập" className="p-button-sm" />
          </Link>
        </div>
      </Dialog>

      <Dialog visible={displayChangePassDone} style={{width: '40rem'}} onHide={() => setDisplayChangePassDone(false)} closable={false}>
        <p>
          <h5>Đặt lại mật khẩu thành công!</h5>
        </p>
        <p>Mật khẩu của quý khách đã được thay đổi, vui lòng sử dụng mật khẩu mới để đăng nhập.</p>
        <div className="flex justify-content-center mt-4">
          <Link to="/login">
            <Button label="Quay lại đăng nhập" className="p-button-sm" />
          </Link>
        </div>
      </Dialog>
    </div>
  );
}
